import React, {Component} from 'react'

import {
    Grid,
    GridCell,
    Spinner,
    css,
    Icon,
    Theme,
    Paginator,
    Select,
} from "@bdfx/mergado-ui-kit"

import trans from "trans";

import {MERGADO_APP, superadminGetRandomImages} from "app/helpers/api";
import {URL} from "app/config/api-config";
import {
    DEFAULT_PAGE_LIMIT,
    FourImagesGrid,
    ProductsImagesType,
    productsPerPageOptions,
    specialOptions,
    StyledProductGrid
} from "./product-images";

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
    selectedProductId: number
}

interface State {
    productsImages: ProductsImagesType
    getRandom: boolean
    groupByImage: boolean
    recentFirst: boolean
    special: string
    isLoading: boolean
}

class RandomImages extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            productsImages: null,
            isLoading: false,
            getRandom: false,
            groupByImage: false,
            special: null,
            recentFirst: true,
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && JSON.stringify(prevProps) !== JSON.stringify(this.props) ||
            (prevState && prevState.special !== this.state.special)
        ) {
            this.getRandomImages(
                this.state.productsImages && this.state.productsImages.page ? this.state.productsImages.page : 1,
                this.state.productsImages && this.state.productsImages.limit ? this.state.productsImages.limit : DEFAULT_PAGE_LIMIT
            )
        }
    }

    getRandomImages = (page : number, limit : number) => {
        const {getRandom, groupByImage, special, recentFirst} = this.state

        superadminGetRandomImages(page, limit, getRandom, groupByImage, recentFirst, special)
            .then((response: any) => {
                this.setState({productsImages: response.data})
            })
            .catch(error => {
                console.error(error.response)
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    componentDidMount() {
        this.getRandomImages(1, DEFAULT_PAGE_LIMIT)
    }

    handlePageChange = (page) => {
        this.getRandomImages(page, this.state.productsImages.limit ?? DEFAULT_PAGE_LIMIT)
    }

    render() {
        const {isLoading, productsImages, special} = this.state

        if (isLoading) {
            return <div>Getting products info <Spinner type={'bubbles'} /></div>
        }

        if (!productsImages || !productsImages.productImages) {
            return <div />
        }

        const ts = new Date().getTime()

        return (
            <div>
                <h2>Random images ({productsImages.totalImages})</h2>

                <FiltersGrid>
                    <GridCell>
                        <Paginator
                            showFirstAndLast={true}
                            showPrevAndNext={true}
                            maxLinks={5}
                            labelFirst={`«« ${trans('first')}`}
                            labelPrevious={`« ${trans('previous')}`}
                            labelNext={`${trans('next')} »`}
                            labelLast={`${trans('last')} »»`}
                            currentPage={productsImages.page}
                            lastPage={productsImages.maxPage}
                            onPageChange={(page) => this.handlePageChange(page)}
                        />
                    </GridCell>
                    <GridCell>
                        <Select
                            options={productsPerPageOptions}
                            value={`${productsImages.limit}`}
                            onChange={(limit) => {
                                this.getRandomImages(1, limit)
                            }}
                        />
                    </GridCell>
                    <GridCell>
                        <Grid cols={'auto 200px'} gap={'10px'}>
                            <GridCell style={{textAlign: 'right', alignSelf: 'center'}}>{trans('type')}</GridCell>
                            <GridCell style={{' .muk-form-group': {marginBottom: '0px'}}}>
                                <Select
                                    options={specialOptions}
                                    value={special || ''}
                                    onChange={(special) => this.setState({special: special})}
                                />
                            </GridCell>
                        </Grid>
                    </GridCell>
                </FiltersGrid>

                <StyledProductGrid dataSpecial={special}>
                    {productsImages.productImages.map(productImage => {
                        return <GridCell key={productImage.productId} className={'shadow-box'}>
                            <div title={`P: ${productImage.templateUpdatedAt}, T: ${productImage.productUpdatedAt}, I: ${productImage.imageUpdatedAt}, R: ${productImage.renderedAt}`}>
                                {productImage.productId} ({productImage.projectId})
                            </div>
                            <div>{productImage.templateName}</div>

                            {productImage.hasWatermarkMask ?
                                <FourImagesGrid>
                                    <GridCell>
                                        <a href={productImage.imageUrl} target={'_blank'}>
                                            <img className={'product-image shadow-box checker'} src={productImage.imageUrl} title={productImage.imageUrl}/>
                                        </a>
                                    </GridCell>
                                    <GridCell>
                                        <img src={`${URL.laravelBase}get-wmremoved/${productImage.projectId}/${productImage.imageUrlHash}?ts=${ts}`} className="product-image shadow-box checker"/>
                                    </GridCell>
                                    <GridCell>
                                        <img src={`${URL.laravelBase}get-wmmask/${productImage.projectId}/${productImage.imageUrlHash}?ts=${ts}`} className="product-image shadow-box checker"/>
                                    </GridCell>
                                    <GridCell>
                                        <a href={productImage.fieLink} target={'_blank'}>
                                            <img className={'product-image checker'} src={productImage.fieLink} title={productImage.productName}/>
                                        </a>
                                    </GridCell>
                                </FourImagesGrid>
                                :
                                <div style={{height: '200px', marginBottom: '5px'}}>
                                    <a href={productImage.fieLink} target={'_blank'}>
                                        <img className={'product-image checker'} src={productImage.fieLink} title={productImage.productName}/>
                                    </a>
                                </div>
                            }

                            <div>
                                {productImage.imageUrl ?
                                    <a href={productImage.imageUrl} target={'_blank'} className={'links'}>
                                        <Icon type={'image-light'} size={iconSize}/>
                                    </a> : <span title={trans('filter_no_image')}>
                                    <Icon type={'times-circle-o'} size={iconSize} color={Theme.red} />
                                </span>
                                }

                                <a href={productImage.shopLink} target={'_blank'} className={'links'} title={trans('link_eshop')}>
                                    <Icon type={'link-light'} size={iconSize} />
                                </a>

                                <a href={`${URL.publicPath}eshop/1/project/${productImage.projectId}/templates/${productImage.templateId}/edit`} target={'_blank'} className={'links'} title={trans('edit_template')}>
                                    <Icon type={'edit-light'} size={iconSize} />
                                </a>

                                <a href={`${MERGADO_APP}/${productImage.productId}`} target={'_blank'} className={'links'} title={trans('link_mergado')}>
                                    <Icon type={'mergado'} size={iconSize} />
                                </a>

                                <span className={'links'} title={`item id ${productImage.itemId}`}>
                                <Icon type={'tag'} size={iconSize} />
                            </span>

                            </div>
                        </GridCell>
                    })}
                </StyledProductGrid>
            </div>
        )
    }
}

const iconSize = 20

const FiltersGrid = css(Grid)({
    gridTemplateColumns: '1fr 100px 1fr',
    gridGap: '5px',
})

export default RandomImages